var render = function render(){var _vm=this,_c=_vm._self._c;return _c('draggable',{attrs:{"tag":"tbody"},on:{"start":function($event){_vm.drag = true},"end":_vm.sortPages},model:{value:(_vm.pages),callback:function ($$v) {_vm.pages=$$v},expression:"pages"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }